import { useMemo } from 'react';
import { metricsStore } from '@globalStore/metricsStore';
import { CURRENT_PRODUCT_MODE } from '@src/utils/constants';

function useSupportedFlowMetrics({ allMetrics, flowId = undefined }: any) {
  const { flowConfigMeta, metricsGroupedByCategory, flowMetricsMeta } = metricsStore.getState();
  const initialState: any = {
    flowConfigMeta: {},
    flowMetricCategoryMeta: {},
    flowMetricCategoryKeys: {},
    flowMetricCategoryOrder: [],
  };

  const flowMetricData = useMemo(() => {
    if (!flowConfigMeta) return initialState;
    let localFlowMeta: any = flowConfigMeta;
    if (flowId) {
      if (!flowConfigMeta[flowId]) return initialState;
      localFlowMeta = {
        [flowId]: flowConfigMeta[flowId] || {},
      };
    }
    const flowMetrics = Object.keys(localFlowMeta).reduce((acc, flowKey: any, index: number) => {
      const flowMetricMeta = localFlowMeta[flowKey];
      let flowMetrics = metricsGroupedByCategory[CURRENT_PRODUCT_MODE.toLowerCase()][flowKey]
        ? Object.values(metricsGroupedByCategory[CURRENT_PRODUCT_MODE.toLowerCase()][flowKey])
        : [];
      if (!flowMetrics.length) return acc;
      flowMetrics = flowMetrics.sort((a: any, b: any) => a.name.localeCompare(b.name));
      acc.flowConfigMeta[flowMetricMeta.id] = flowId ? flowMetricsMeta[flowId] : flowMetrics;
      acc.flowMetricCategoryKeys[flowMetricMeta.id] = flowMetricMeta.id;
      acc.flowMetricCategoryOrder.push(flowMetricMeta.id);
      acc.flowMetricCategoryMeta[flowKey] = {
        displayName: flowMetricMeta.name,
        order: index,
      };
      return acc;
    }, initialState);
    return flowMetrics;
  }, [flowConfigMeta, allMetrics, flowId]);
  return flowMetricData;
}

export default useSupportedFlowMetrics;
